export enum InstitutionState {
  BADENWURTTEMBERG = 'BADENWURTTEMBERG',
  BAYERN = 'BAYERN',
  BERLIN = 'BERLIN',
  BRANDENBURG = 'BRANDENBURG',
  BREMEN = 'BREMEN',
  HAMBURG = 'HAMBURG',
  HESSEN = 'HESSEN',
  MECKLENBURGVORPOMMERN = 'MECKLENBURGVORPOMMERN',
  NIEDERSACHSEN = 'NIEDERSACHSEN',
  NORDRHEINWESTFALEN = 'NORDRHEINWESTFALEN',
  RHEINLANDPFALZ = 'RHEINLANDPFALZ',
  SAARLAND = 'SAARLAND',
  SACHSENANHALT = 'SACHSENANHALT',
  SACHSEN = 'SACHSEN',
  SCHLESWIGHOLSTEIN = 'SCHLESWIGHOLSTEIN',
  THURINGEN = 'THURINGEN',
}
